var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "bold blc-color",
    attrs: {
      "id": "Client-name"
    }
  }, [_vm._v(" Posudok " + _vm._s(_vm.type.label) + " ")])]), _c('div', {
    staticClass: "splitter"
  }, [_vm._v("Objednávateľ")]), _vm._m(0), _c('div', {
    staticClass: "email-cta"
  }, [_c('img', {
    staticClass: "nav-link-icon small filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f21_icons8-mail.svg",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "cta-email"
  }, [_c('div', {
    staticClass: "light-text lightgrey"
  }, [_vm._v("Email")]), _c('a', {
    staticClass: "blc-color pointer",
    attrs: {
      "href": "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=$",
      "target": "_blank"
    }
  }, [_vm._v(" petrovic@osobnimakleri.sk ")])])]), _vm._m(1), _c('div', {
    staticClass: "popup-block"
  }, [_c('div', {
    staticClass: "icons-wrapper"
  }, [_c('testimonial-deadline-handler'), _c('document-cloud-handler', {
    attrs: {
      "cloud-meta": null,
      "rules": ['single'],
      "text-icon-button": ""
    }
  }), _vm._m(2), _c('testimonial-overview-handler')], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header-block inline"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Dominik Petrovič")]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "email-cta"
  }, [_c('img', {
    staticClass: "nav-link-icon small filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f20_icons8-shake-phone.svg",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "cta-email"
  }, [_c('div', {
    staticClass: "light-text lightgrey"
  }, [_vm._v("Telefón")]), _c('div', {
    staticClass: "blc-color"
  }, [_vm._v(" 0950 880 132 ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1b_icons8-trash.svg"
    }
  })]);

}]

export { render, staticRenderFns }